import { Tag } from 'antd';
import { ComponentProps } from 'react';
import { Trans } from 'react-i18next';

export default function CustomTrans({ components, ...props }: ComponentProps<typeof Trans>) {
  return (
    <Trans
      {...props}
      components={{
        ...components,
        ErrorCode: <Tag color="error" className="tw:mr-(--spacing-1)" />,
      }}
    />
  );
}
